import api from "@/lib/api";

export async function downloadCsv(path, params = {}) {
  const r = await api.get(path, { params, responseType: "blob" });
  if (!(r.headers["content-type"] || "").includes("text/csv")) throw new Error("Réponse invalide");
  const disp = r.headers["content-disposition"] || "";
  const match = disp.match(/filename="?([^"]+)"?/);
  const filename = match ? match[1] : "export.csv";
  const url = URL.createObjectURL(r.data);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}
